import { useMemo } from 'react';
import { useRechargePaymentPage } from '../../../hooks/useRechargePaymentPage';
export function useRechargePaymentBankSlipPage() {
    const config = useMemo(() => ({
        codeField: 'bankSlipSerialNumber',
        translationKeys: {
            pdfUnavailable: 'benefits.recharge.payment.bankSlip.alerts.pdfUnavailable',
            paymentLoadingError: 'benefits.recharge.payment.bankSlip.alerts.paymentLoadingError',
            codeCopied: 'benefits.recharge.payment.bankSlip.alerts.barCodeCopied',
            generatingCode: 'benefits.recharge.payment.bankSlip.alerts.generatingBarCode',
            codeGenerated: 'benefits.recharge.payment.bankSlip.alerts.barCodeGenerated',
            codeNotGenerated: 'benefits.recharge.payment.bankSlip.alerts.barCodeNotGenerated',
        },
    }), []);
    const { alertData, recharge, paymentCode, isPaymentCodeLoading, isPaymentCodeError, isDataReady, isBankSlipLoading, isAnnotationVisible: isBankSlipAnnotationVisible, setAlertData, handleGenerateCode: handleGenerateBarCode, handleCopyCode: handleCopyBarCode, handleDownloadBankslip, handleCloseAnnotation: handleCloseBankSlipAnnotation, } = useRechargePaymentPage(config);
    return {
        alertData,
        recharge,
        paymentCode,
        isPaymentCodeLoading,
        isPaymentCodeError,
        isDataReady,
        isBankSlipLoading,
        isBankSlipAnnotationVisible,
        setAlertData,
        handleGenerateBarCode,
        handleCopyBarCode,
        handleDownloadBankslip,
        handleCloseBankSlipAnnotation,
    };
}
